// extracted by mini-css-extract-plugin
export default {"root":"MaintenancePage_root_uMS0L","content":"MaintenancePage_content_AR66X","logo":"MaintenancePage_logo_tVPZz"};